/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserSummary {
    getFixupPrototypeFunction() { return UserSummary.fixupPrototype; }

    static newInstance(model: Partial<UserSummary>): UserSummary {
        let obj = Object.assign(new UserSummary(), model);
        UserSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserSummary>): UserSummary {
        if (!model) return null;
        return UserSummary.newInstance(<UserSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserSummary) {
        if (!obj) return;

        models.UserSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserSummary): boolean {
        Object.setPrototypeOf(obj, UserSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the User
     */
    name: string;

    /**
     * User email
     */
    email: string;

    /**
     * Status of the user
     */
    status: models.UserStatus;

}
